import { Component } from "@angular/core";

@Component({
    selector: "adapt-application-bar-coach-chat-item",
    templateUrl: "./application-bar-coach-chat-item.component.html",
    standalone: false,
})
export class ApplicationBarCoachChatItemComponent { }
